module.exports = __webpack_public_path__ + "assets/7a715a77585919b43273ded5b0d2cca3.mp3";